import React, { useEffect, useState } from 'react';
import { Flex, Form, Input, Modal } from 'antd';
import { ReactComponent as CrossIcon } from '../../../../assets/images/global-icons/cross_ic.svg';
import './EditEmailModal.scss';
import CustomButton from '../../../UI/CustomButton/CustomButton';
import { useForm } from 'antd/lib/form/Form';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import { CheckEmailModal } from '../CheckEmailModal/CheckEmailModal';
import { useRequestChangeEmailMutation } from '../../../../redux/API/userSlice';

interface EditEmailModalProps {
  visible: boolean;
  onClose: (wasConfirmed: boolean) => void;
  email: string;
  userId: string;
}

const EditEmailModal = ({ visible, onClose, email, userId }: EditEmailModalProps) => {
  const [form] = useForm();
  const { isAuth } = useSelector((state: RootState) => state.isAuth);
  const [isDisabled, setIsDisabled] = useState(true);
  const [requestChangeEmail] = useRequestChangeEmailMutation();
  const [mode, setMode] = useState<'form' | 'confirmation'>('form');

  useEffect(() => {
    form.setFieldValue('email', email);
    setIsDisabled(true);
  }, [visible, email]);

  const handleFinish = async () => {
    try {
      await requestChangeEmail({ accessToken: isAuth, email: form.getFieldValue('email') }).unwrap();
      setMode('confirmation');
    } catch (error) {
      console.error('Error sending change email link:', error);
    }
  };

  const handleInputChange = () => {
    const newEmail = form.getFieldValue('email');
    setIsDisabled(newEmail === email || !form.isFieldTouched('email'));
  };
  const handleModalClose = () => {
    const wasConfirmed = mode === 'confirmation';
    setMode('form');
    onClose(wasConfirmed);
  };

  return (
    <Modal
      open={visible}
      footer={null}
      closable={false}
      maskClosable={true}
      onCancel={handleModalClose}
      centered
      className="EditEmailModal"
    >
      <Flex vertical>
        <Flex justify="space-between" align="center" className="EditEmailModal__header">
          <h3>Change Email Address</h3>
          <CrossIcon color="#000" onClick={handleModalClose} />
        </Flex>

        <Flex className="EditEmailModal__body" vertical align="center">
          {mode === 'form' ? (
            <Form
              form={form}
              initialValues={{ email }}
              onFinish={handleFinish}
              layout="vertical"
              className="EditEmailModal__body__form"
              onValuesChange={handleInputChange}
            >
              <Form.Item
                name="email"
                label="E-mail"
                rules={[
                  { required: true, message: '' },
                  { type: 'email', message: 'Please enter a valid email' }
                ]}
              >
                <Input placeholder="Email" className="EditEmailModal__body__form__input" />
              </Form.Item>

              <Form.Item>
                <Flex className="EditEmailModal__body__form__button">
                  <CustomButton text="Next" disable={isDisabled} htmlType="submit" />
                </Flex>
              </Form.Item>
            </Form>
          ) : (
            <CheckEmailModal
              text="We've sent a link to confirm your email change. Once confirmed, all changes will be applied to your profile."
              onResend={handleFinish}
            />
          )}
        </Flex>
      </Flex>
    </Modal>
  );
};

export default EditEmailModal;
